<template>
  <div class="rooote">
    <div class="body_html">
      <h1>系统管理员</h1>
      <div class="wei_body">
        <div class="tianjia">
          <main>权限列表</main>
          <el-table
            :data="tableData"
            style="width: 100%;"
            row-key="id"
            :tree-props="{ child: 'children', hasChildren: 'hasChildren' }"
          >
            <el-table-column
              prop="label"
              label="权限名字"
              sortable
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      tableData: [],
      hasChildren: true,
      tooken: "",
      title: {},
    };
  },
  mounted() {
    if (window.sessionStorage.getItem("title")) {
      let title = JSON.parse(window.sessionStorage.getItem("title"));
      this.title = title;
      var a = document.title;
      document.title = title[0].website + "-" + a;
    }
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据
    if (window.sessionStorage.getItem("userinfone")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfone"));
      this.tooken = userinfo;
    }
    this.abo();
  },
  methods: {
    abo() {
      this.axios
        .post(
          "/api/role/getPrivilegeList",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
  },
};
</script>
<style>
.el-table .el-table--fit .el-table--enable-row-transition {
  margin-bottom: 10.0rem;
}
</style>
<style scoped>
.wei_body {
  margin-top: 42px;
  width: 1671px;
  height: 942px;
  background-color: #ffffff;
  box-shadow: .0rem 1px 6px .0rem rgba(0, 0, 0, 0.2);
  padding: 23px 31px;
  overflow: hidden;
  overflow-y: scroll;
}
.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia > main {
  font-size: 26px;
}
.bule {
  width: 100%;
  height: 69px;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
</style>

